import { Section, VariableType } from '@/lib/interfaces/ApiControl';

export function replaceGlobalVariablesSimplified(
	obj: Section[],
	globalVariables: VariableType,
): any {
	// Convert the object to a JSON string
	let jsonString = JSON.stringify(obj);

	// Replace all occurrences of the global variables
	Object.keys(globalVariables).forEach((key) => {
		const value = globalVariables[key];
		const regex = new RegExp(key, 'g');
		jsonString = jsonString.replace(regex, value);
	});

	// Parse the string back into a JSON object
	return JSON.parse(jsonString);
}
